(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const createRail = (section) => {
      if (instances.has(section)) return;

      const rail = section.querySelector('[data-ot-editorial-rail]');
      const controls = section.querySelector('[data-ot-editorial-controls]');
      if (!rail || !controls) return;

      const items = Array.from(rail.querySelectorAll('.ot-editorial__item'));
      const previous = controls.querySelector('[data-ot-editorial-previous]');
      const next = controls.querySelector('[data-ot-editorial-next]');
      const current = controls.querySelector('[data-ot-editorial-current]');
      const status = controls.querySelector('[data-ot-editorial-status]');
      if (items.length < 2 || !previous || !next || !current || !status) return;

      let currentIndex = 0;
      let frame;

      const closestIndex = () => {
        const railLeft = rail.getBoundingClientRect().left;
        let closest = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - railLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            closest = index;
          }
        });

        return closest;
      };

      const update = (announce = false) => {
        const nextIndex = closestIndex();
        const changed = nextIndex !== currentIndex;
        currentIndex = nextIndex;
        current.textContent = String(currentIndex + 1);
        previous.disabled = currentIndex === 0;
        next.disabled = currentIndex === items.length - 1;

        if (announce && changed) {
          status.textContent = `Collection ${currentIndex + 1} of ${items.length}`;
        }
      };

      const scheduleUpdate = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => update(true));
      };

      const moveTo = (index) => {
        const target = items[Math.max(0, Math.min(index, items.length - 1))];
        if (!target) return;

        target.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      };

      const handlePrevious = () => moveTo(currentIndex - 1);
      const handleNext = () => moveTo(currentIndex + 1);
      const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(scheduleUpdate);

      previous.addEventListener('click', handlePrevious);
      next.addEventListener('click', handleNext);
      rail.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      resizeObserver?.observe(rail);
      update();

      instances.set(section, {
        moveTo,
        destroy() {
          window.cancelAnimationFrame(frame);
          previous.removeEventListener('click', handlePrevious);
          next.removeEventListener('click', handleNext);
          rail.removeEventListener('scroll', scheduleUpdate);
          window.removeEventListener('resize', scheduleUpdate);
          resizeObserver?.disconnect();
        }
      });
    };

    const initialize = (container = document) => {
      if (container.matches?.('[data-ot-editorial-section]')) createRail(container);
      container.querySelectorAll?.('[data-ot-editorial-section]').forEach(createRail);
    };

    const unload = (container) => {
      const sections = container.matches?.('[data-ot-editorial-section]')
        ? [container]
        : Array.from(container.querySelectorAll?.('[data-ot-editorial-section]') || []);

      sections.forEach((section) => {
        instances.get(section)?.destroy();
        instances.delete(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => unload(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('.ot-editorial__item');
      const section = item?.closest('[data-ot-editorial-section]');
      if (!item || !section) return;

      const items = Array.from(section.querySelectorAll('.ot-editorial__item'));
      instances.get(section)?.moveTo(items.indexOf(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otFeaturedProductsRailBound) {
    window.__otFeaturedProductsRailBound = true;

    (() => {
      const instances = new WeakMap();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const initializeRail = (scope) => {
        const rail = scope.matches?.('[data-ot-product-rail]') ? scope : scope.querySelector?.('[data-ot-product-rail]');
        if (!rail || instances.has(rail)) return;

        const root = rail.closest('.ot-featured-products');
        const controls = root?.querySelector('[data-ot-product-rail-controls]');
        const cards = Array.from(rail.querySelectorAll('.ot-featured-products__card'));
        if (!controls || cards.length < 2) return;

        const previous = controls.querySelector('[data-ot-product-rail-previous]');
        const next = controls.querySelector('[data-ot-product-rail-next]');
        const current = controls.querySelector('[data-ot-product-rail-current]');
        const progress = controls.querySelector('[data-ot-product-rail-progress]');
        const status = controls.querySelector('[data-ot-product-rail-status]');
        if (!previous || !next || !current || !progress || !status) return;

        let currentIndex = 0;
        let frame;

        const getIndex = () => {
          let closestIndex = 0;
          let closestDistance = Infinity;
          cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - rail.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        };

        const update = (announce = false) => {
          const nextIndex = getIndex();
          const changed = nextIndex !== currentIndex;
          currentIndex = nextIndex;
          current.textContent = String(currentIndex + 1);
          previous.disabled = currentIndex === 0;
          next.disabled = currentIndex === cards.length - 1;
          progress.style.setProperty('--ot-rail-progress', String((currentIndex + 1) / cards.length));
          if (announce && changed) status.textContent = `Product ${currentIndex + 1} of ${cards.length}`;
        };

        const scheduleUpdate = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = undefined;
            update(true);
          });
        };

        const move = (direction) => {
          const targetIndex = Math.max(0, Math.min(cards.length - 1, getIndex() + direction));
          cards[targetIndex].scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        };

        const onPrevious = () => move(-1);
        const onNext = () => move(1);
        const resizeObserver = new ResizeObserver(() => update(false));

        previous.addEventListener('click', onPrevious);
        next.addEventListener('click', onNext);
        rail.addEventListener('scroll', scheduleUpdate, { passive: true });
        resizeObserver.observe(rail);
        update(false);

        instances.set(rail, () => {
          previous.removeEventListener('click', onPrevious);
          next.removeEventListener('click', onNext);
          rail.removeEventListener('scroll', scheduleUpdate);
          resizeObserver.disconnect();
          if (frame) window.cancelAnimationFrame(frame);
          instances.delete(rail);
        });
      };

      document.querySelectorAll('[data-ot-product-rail]').forEach(initializeRail);
      document.addEventListener('shopify:section:load', (event) => initializeRail(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll?.('[data-ot-product-rail]').forEach((rail) => instances.get(rail)?.());
      });
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otNewsletterPopupBound) {
    window.__otNewsletterPopupBound = true;

    const storage = {
      get(area, key) {
        try {
          return area.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set(area, key, value) {
        try {
          area.setItem(key, value);
        } catch (error) {
          return;
        }
      },
      remove(area, key) {
        try {
          area.removeItem(key);
        } catch (error) {
          return;
        }
      }
    };

    const bindPopup = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.otBound === 'true') return;

      dialog.dataset.otBound = 'true';

      const closeButton = dialog.querySelector('[data-ot-newsletter-close]');
      const emailInput = dialog.querySelector('input[type="email"]');
      const form = dialog.querySelector('form');
      const hasSuccess = Boolean(dialog.querySelector('[data-ot-newsletter-success]'));
      const hasError = Boolean(dialog.querySelector('[data-ot-newsletter-error]'));
      const designMode = dialog.dataset.designMode === 'true';
      const delay = Math.max(Number(dialog.dataset.delay) || 8, 0);
      const scrollDepth = Math.max(Number(dialog.dataset.scrollDepth) || 15, 0);
      const dismissDays = Math.max(Number(dialog.dataset.dismissDays) || 30, 1);
      const stateKey = `ot-newsletter-popup:${dialog.id}:v1`;
      const submitKey = `${stateKey}:submitting`;
      const scrollRoot = document.querySelector('.page-wrapper') || document.scrollingElement;
      const usesWindowScroll = scrollRoot === document.documentElement || scrollRoot === document.body;
      const scrollTarget = usesWindowScroll ? window : scrollRoot;
      let delayReady = false;
      let scrollReady = scrollDepth === 0;
      let triggerTimer;
      let previousFocus;

      const readState = () => {
        const rawState = storage.get(window.localStorage, stateKey);
        if (!rawState) return null;

        try {
          const parsedState = JSON.parse(rawState);
          if (!parsedState.expires || Date.now() >= parsedState.expires) {
            storage.remove(window.localStorage, stateKey);
            return null;
          }
          return parsedState;
        } catch (error) {
          storage.remove(window.localStorage, stateKey);
          return null;
        }
      };

      const writeState = (value, days) => {
        storage.set(window.localStorage, stateKey, JSON.stringify({
          value,
          expires: Date.now() + days * 86400000
        }));
      };

      const stopTriggers = () => {
        window.clearTimeout(triggerTimer);
        scrollTarget?.removeEventListener('scroll', updateScroll);
      };

      const showPopup = () => {
        if (!dialog.isConnected || dialog.open) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('ot-newsletter-popup-open');
        window.requestAnimationFrame(() => emailInput?.focus({ preventScroll: true }));
      };

      const maybeOpen = () => {
        if (!delayReady || !scrollReady || readState()) return;
        stopTriggers();
        showPopup();
      };

      const updateScroll = () => {
        const scrollTop = usesWindowScroll ? window.scrollY : scrollRoot.scrollTop;
        const scrollHeight = usesWindowScroll ? document.documentElement.scrollHeight : scrollRoot.scrollHeight;
        const clientHeight = usesWindowScroll ? window.innerHeight : scrollRoot.clientHeight;
        const scrollableDistance = Math.max(scrollHeight - clientHeight, 1);
        const currentDepth = (scrollTop / scrollableDistance) * 100;
        if (scrollTop >= 64 && currentDepth >= scrollDepth) {
          scrollReady = true;
          maybeOpen();
        }
      };

      const submittedHere = storage.get(window.sessionStorage, submitKey) === '1';

      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ot-newsletter-popup-open');
        stopTriggers();
        if (!hasSuccess) writeState('dismissed', dismissDays);
        if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
      });

      if (hasSuccess) {
        writeState('subscribed', 365);
        storage.remove(window.sessionStorage, submitKey);
        if (submittedHere) showPopup();
        return;
      }

      if (hasError) {
        storage.remove(window.sessionStorage, submitKey);
        if (submittedHere) showPopup();
        return;
      }

      if (designMode) {
        showPopup();
        return;
      }

      if (readState()) return;

      form?.addEventListener('submit', () => {
        storage.set(window.sessionStorage, submitKey, '1');
      });

      triggerTimer = window.setTimeout(() => {
        delayReady = true;
        maybeOpen();
      }, delay * 1000);

      scrollTarget?.addEventListener('scroll', updateScroll, { passive: true });
      updateScroll();
    };

    const initializePopups = (root = document) => {
      root.querySelectorAll('[data-ot-newsletter-popup]').forEach(bindPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializePopups(), { once: true });
    } else {
      initializePopups();
    }

    document.addEventListener('shopify:section:load', (event) => initializePopups(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-premium-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otPremiumHeroScrollBound) {
    window.__otPremiumHeroScrollBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ot-scroll-next]');
      if (!trigger) return;

      const sectionWrapper = trigger.closest('.shopify-section');
      const nextSection = sectionWrapper ? sectionWrapper.nextElementSibling : null;
      if (!nextSection) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      nextSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
